import React from 'react';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import ContactForm from '../ContactForm';
import { pageTitle } from '../../helpers/PageTitle';

export default function Contact() {
  pageTitle('Liên hệ');
  return (
    <>
      <Section topMd={170} bottomMd={54} bottomLg={40}>
        <Breadcrumb title='Liên hệ' />
        <div className='container'>
          <p
            style={{
              fontSize: '18px',
              lineHeight: '1.6',
              color: '#555',
              marginTop: '12px',
            }}
          >
            Hãy để lại thông tin, chúng tôi sẽ liên hệ tư vấn cho bạn sớm nhất
          </p>
        </div>
      </Section>
      <Section bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className='container'>
          <ContactForm />
        </div>
      </Section>
    </>
  );
}
